export const modalI18NNS = 'uiModal';
